/**
 * Singapura AR — Active-Exempt-unaudited AGM 5종(1.a~1.e) 폼값 → 템플릿 [[변수]] 변환.
 *   · 조건값(members_scope/director_rotation/remuneration_mode/declare_dividend)은 백엔드 [[if …]] 가 그대로 소비.
 *   · members_scope 는 멤버 수로 파생(sole/all) — 화면 미지정 시 자동.
 *   · 서명 [[Signers]] 는 문서별 signers 배열로 백엔드가 렌더(패널이 prepare-documents 에 문서별 주입).
 *   · 날짜는 여기서 "30 June 2026"(고객 원본 표기)으로 바꿔 넘긴다 — 세션 형식(dd/MM/yyyy)을 따르지 않음(utils/longDate).
 */
import { longDateDeep } from './longDate';

export function normalizeSingapuraAgmForWord(input: Record<string, any>): Record<string, any> {
  const out: Record<string, any> = { ...input };

  const st = (v: unknown) => String(v ?? '').trim();

  // members_scope: 미지정이면 멤버 수로 파생(1명=sole, 그 외=all).
  if (!st(out.members_scope)) {
    const n = parseInt(st(out.member_count), 10);
    out.members_scope = Number.isFinite(n) && n === 1 ? 'sole' : 'all';
  }

  // director_rotation: 미지정이면 이사 수로 파생(1명=none, 그 외=single).
  if (!st(out.director_rotation)) {
    const n = parseInt(st(out.director_count), 10);
    out.director_rotation = Number.isFinite(n) && n <= 1 ? 'none' : 'single';
  }

  // remuneration_mode 기본값 none, declare_dividend 기본값 no — 미지정 시 빈 분기 방지.
  if (!st(out.remuneration_mode)) out.remuneration_mode = 'none';

  // auditor_mode: 'reappoint'(퇴임 감사인 재선임) / 'none'(감사인 선임 불요).
  //   미지정(기존 태스크)은 기존 문안 그대로 나가도록 reappoint 로 본다 — 화면 computed 와 동일 규칙.
  if (st(out.auditor_mode) !== 'none') out.auditor_mode = 'reappoint';

  // (1.a) DRW (3)항 서명 이사(ds_authorised_directors) — 수동입력 우선, 비면 이사명에서 도출(생성물 공란 방지).
  //   ⚠ 키명은 'sign/signatory/signer' 로 끝나면 백엔드가 서명필드로 오인(UI_SIGNER_PICKER_RE)해 텍스트 치환을
  //     건너뛰므로 반드시 'ds_authorised_directors' 처럼 서명 단어로 끝나지 않는 이름을 쓴다.
  if (!st(out.ds_authorised_directors)) {
    out.ds_authorised_directors =
      st(out.retiring_directors) || st(out.retiring_director_name) || st(out.chairman_name) || '';
  }

  // 날짜 → 고객 원본 Word 표기 "30 June 2026"(월 전체 이름, 일자 앞 0 없음) — 고객 요청 2026-10-15.
  //   백엔드 치환기는 ISO 만 세션 형식(dd/MM/yyyy)으로 바꾸므로 이미 바뀐 글자는 그대로 나간다.
  return longDateDeep(out);
}
